function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
export default (function (_ref) {
  var name = _ref.name,
      ClassComponent = _ref.ClassComponent;

  function Internal(props, ref) {
    return /*#__PURE__*/React.createElement(ClassComponent, _extends({}, props, {
      node: ref,
      forwardedRef: ref
    }));
  }

  Internal.displayName = name;
  var ComponentWithRefForwarding = /*#__PURE__*/forwardRef(Internal); // preserve all Static properties and methods

  Object.keys(ClassComponent).forEach(function (x) {
    ComponentWithRefForwarding[x] = ClassComponent[x];
  });
  return ComponentWithRefForwarding;
});